import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const walletDrawerstyles = makeStyles((theme: Theme) =>
  createStyles({
    headerContainer: {
      padding: "30px 20px 0px 30px",
    },
    currencyTitle: {
      fontSize: "16px",
      color: theme.palette.text.secondary,
      marginTop: "12px",
      fontWeight: 600,
    },
    icon: {
      alignItems: "self-start",
      width: 40,
      marginTop: "8px",
      marginRight: "10px",
      marginLeft: "15px",
    },
    listContainer: {
      padding: "0px",
      alignItems: "start",
      width: "100%",
    },
    Title: {
      fontSize: "16px",
      color: theme.palette.text.disabled,
      fontWeight: 600,
    },
    Subtitle: {
      fontSize: "14px",
      color: theme.palette.text.secondary,
      fontWeight: 400,
    },
    Button: {
      padding: "0px",
      fontSize: "16px",
      color: theme.palette.text.disabled,
      fontWeight: 600,
      alignItems: "normal",
      marginTop: "8px",
    },
    Icon: {
      height: "30px",
      width: "30px",
      marginRight: "5px",
    },
    bottomDrawer: {
      width: "100%",
      height: "200px",
    },
    infiniteScroll: {
      overflowY: "hidden",
      width: "100vw",
    },
    searchbarContainer: {
      width: "100%",
      height: "100%",
    },
    searchbar: {
      borderRadius: "6px",
      fontWeight: 400,
      fontSize: "1rem",
      color: theme.palette.primary.main,
      cursor: "text",
      width: "100%",
      height: "48px",
      display: "flex",
      justifyContent: "space-between",
      textTransform: "none",
      "& .MuiOutlinedInput-root": {
        height: "100%",
      },
    },
    searchList: {
      maxHeight: "400px",
      overflowY: "auto",
      marginTop: "10px",
      borderRadius: "6px",
      minWidth: "100%",
      height: "auto",
      border: "1px solid #e7e7e7",
      backgroundColor: "#fff",
      position: "relative",
      zIndex: 99,
    },
    searchBar: {
      padding: "15px 22px",
    },
    searchbarIcon: {
      marginRight: "12px",
    },
    error: {
      color: "red",
      padding: "0px 10px",
    },
  }),
);
